module.exports = "img/39.8e5f80.webp";